var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { insuredClearData, patchInsured, postInsured, postInsuredClearData, } from "../../../store/insured/actions";
import { newFormattedDate, newFormattedDateYYMMDD } from "../../../utils/date";
import { removeNonNumeric } from "../../../services/functions";
import { formatPhoneNumber } from "../../../utils/formats";
var useInsurance = function (setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, insuranceType, setRows, responseOneQuote, quoteId, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredTypeOptions, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast) {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var handleAddInsured = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        setTitleInsured("Ingresar Asegurado");
        setIsUpdate(false);
        if (showNewFormInsurance) {
            setOpenModal(true);
        }
        else {
            setOpenModalAddInsurance(true);
        }
        // Reiniciamos el formulario simple (dataFormInsurance) usado por otro modal
        setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { Id: "", DocumentNumber: "", Name: "", SecondName: "", LastNameA: "", LastNameB: "", marriedName: "", Birthday: "", PhoneNumber: "", IdTypeName: "" }));
        // Reiniciamos también el formulario extendido (dataFormInsuranceSp) que consume FormAddInsuranceAFY
        // Si no se resetea, pueden quedar valores "tocados" o vacíos marcados como requeridos.
        var quoteData = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
        setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idType: "", idInsuredType: insuranceType, documentNumber: "", firstName: "", secondName: "", lastNameA: "", lastNameB: "", birthday: "", 
            // Pre-fill with quote/client defaults to avoid required-but-hidden fields
            gender: (_b = (_a = quoteData === null || quoteData === void 0 ? void 0 : quoteData.catalogGender) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "", marriedName: "", country: (_e = (_d = (_c = quoteData === null || quoteData === void 0 ? void 0 : quoteData.nationality) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : dataFormInsuranceSp.country) !== null && _e !== void 0 ? _e : "", province: (_g = (_f = quoteData === null || quoteData === void 0 ? void 0 : quoteData.province) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : "", town: (_j = (_h = quoteData === null || quoteData === void 0 ? void 0 : quoteData.municipality) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : "", sector: (_l = (_k = quoteData === null || quoteData === void 0 ? void 0 : quoteData.district) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : "", postalCode: (_m = quoteData === null || quoteData === void 0 ? void 0 : quoteData.zip) !== null && _m !== void 0 ? _m : "", address1: (_o = quoteData === null || quoteData === void 0 ? void 0 : quoteData.address1) !== null && _o !== void 0 ? _o : "", phoneHome: (_p = quoteData === null || quoteData === void 0 ? void 0 : quoteData.phone1) !== null && _p !== void 0 ? _p : "", phoneNumber: (_q = quoteData === null || quoteData === void 0 ? void 0 : quoteData.phone3) !== null && _q !== void 0 ? _q : "", phoneOffice: (_r = quoteData === null || quoteData === void 0 ? void 0 : quoteData.phone2) !== null && _r !== void 0 ? _r : "", email: (_s = quoteData === null || quoteData === void 0 ? void 0 : quoteData.email) !== null && _s !== void 0 ? _s : "" }));
    };
    var setInsuranceStorybook = useCallback(function (responseInsured) {
        var beneficiaryRows = responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.map(function (I) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            return ({
                id: I.id,
                type: (_b = (_a = I.catalogInsuredTypeInfo) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : "",
                names: "".concat((_d = (_c = I.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameA) !== null && _d !== void 0 ? _d : "", " ").concat((_f = (_e = I.personInfo) === null || _e === void 0 ? void 0 : _e.firstNameB) !== null && _f !== void 0 ? _f : ""),
                lastNames: "".concat((_h = (_g = I.personInfo) === null || _g === void 0 ? void 0 : _g.lastNameA) !== null && _h !== void 0 ? _h : "", " ").concat((_k = (_j = I.personInfo) === null || _j === void 0 ? void 0 : _j.lastNameB) !== null && _k !== void 0 ? _k : ""),
                marriedName: (_m = (_l = I.personInfo) === null || _l === void 0 ? void 0 : _l.marriedName) !== null && _m !== void 0 ? _m : "",
                phone1: (_p = formatPhoneNumber(((_o = I.personInfo) === null || _o === void 0 ? void 0 : _o.phone1) || "")) !== null && _p !== void 0 ? _p : "",
                dob: (_r = newFormattedDate((_q = I.personInfo) === null || _q === void 0 ? void 0 : _q.dob)) !== null && _r !== void 0 ? _r : "",
                documentNumber: (_t = (_s = I.personInfo) === null || _s === void 0 ? void 0 : _s.numberId) !== null && _t !== void 0 ? _t : "",
                idType: (_v = (_u = I.personInfo) === null || _u === void 0 ? void 0 : _u.identificationTypeId) !== null && _v !== void 0 ? _v : "",
                idInsuredType: (_x = (_w = I.catalogInsuredTypeInfo) === null || _w === void 0 ? void 0 : _w.id) !== null && _x !== void 0 ? _x : "",
                firstNameA: (_y = I.personInfo) === null || _y === void 0 ? void 0 : _y.firstNameA,
                firstNameB: (_z = I.personInfo) === null || _z === void 0 ? void 0 : _z.firstNameB,
                lastNameA: (_0 = I.personInfo) === null || _0 === void 0 ? void 0 : _0.lastNameA,
                lastNameB: (_1 = I.personInfo) === null || _1 === void 0 ? void 0 : _1.lastNameB,
            });
        });
        setRows(beneficiaryRows);
        dispatch(insuredClearData());
        dispatch(postInsuredClearData());
    }, [dispatch]);
    var handleSubmitInsured = useCallback(function (data) {
        var _a, _b, _c, _d;
        var selectedInsuredType = insuredTypeOptions === null || insuredTypeOptions === void 0 ? void 0 : insuredTypeOptions.find(function (option) { return option.value === data.idInsuredType; });
        var insuredTypeCode = (_a = selectedInsuredType === null || selectedInsuredType === void 0 ? void 0 : selectedInsuredType.code) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        var calculateAge = function (dateString) {
            if (!dateString) {
                return null;
            }
            var birthDate = new Date(dateString);
            if (Number.isNaN(birthDate.getTime())) {
                return null;
            }
            var today = new Date();
            var age = today.getFullYear() - birthDate.getFullYear();
            var monthDifference = today.getMonth() - birthDate.getMonth();
            if (monthDifference < 0 ||
                (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
                age -= 1;
            }
            return age;
        };
        // Valida que la fecha de nacimiento sea real: no vacía, parseable, no
        // futura y dentro de un rango razonable. Sin esto, una fecha inválida
        // (ej. "2021534654") produce una edad negativa que el formulario
        // interpreta como menor de edad y permite guardar sin documento.
        var birthdayValue = data.Birthday || data.birthday;
        var birthDate = birthdayValue ? new Date(birthdayValue) : null;
        var isValidBirthDate = !!birthDate &&
            !Number.isNaN(birthDate.getTime()) &&
            birthDate.getTime() <= Date.now() &&
            birthDate.getFullYear() >= 1900;
        if (!isValidBirthDate) {
            setSeeToast({
                show: true,
                message: "La fecha de nacimiento no es válida.",
                type: typeAlert.error,
            });
            return;
        }
        if (insuredTypeCode === "s") {
            var age = calculateAge(birthdayValue);
            if (age === null || age < 18) {
                setSeeToast({
                    show: true,
                    message: "El cónyuge debe ser mayor de edad.",
                    type: typeAlert.error,
                });
                return;
            }
        }
        var body = {
            quoteId: quoteId,
            catalogInsuredType: data.idInsuredType,
            person: {
                firstNameA: data.Name || data.firstName,
                firstNameB: (_b = data.SecondName) !== null && _b !== void 0 ? _b : "",
                lastNameA: data.LastNameA || data.FirstLastName || data.lastNameA,
                lastNameB: (_c = (data.LastNameB || data.SecondLastName)) !== null && _c !== void 0 ? _c : "",
                identificationTypeId: data.IdType || data.idType,
                numberId: (data.DocumentNumber || data.documentNumber || "").replace(/-/g, ""),
                dob: data.Birthday || data.birthday,
                catalogGender: data.Gender || data.gender,
                marriedName: (_d = (data.marriedName || data.MarriedSurName)) !== null && _d !== void 0 ? _d : "",
                nationality: data.Country || data.country,
                province: data.Province || data.province,
                municipality: data.Town || data.town,
                district: data.Sector || data.sector,
                zip: data.PostalCode || data.postalCode,
                address1: data.Address1 || data.address1,
                phone1: removeNonNumeric(data.PhoneNumber || data.phoneNumber || null),
                phone3: removeNonNumeric(data.PhoneHome || data.phoneHome || null),
                phone2: removeNonNumeric(data.PhoneOffice || data.phoneOffice || null),
                email: data.Email || data.email,
                clientId: clientId,
            },
        };
        if (isUpdate) {
            dispatch(patchInsured({ body: body, id: personId }));
            setOpenModal(false);
        }
        else {
            dispatch(postInsured(body));
        }
    }, [
        clientId,
        insuredTypeOptions,
        isUpdate,
        personId,
        quoteId,
        setOpenModal,
        setSeeToast,
    ]);
    var editInsured = function (row) {
        setIsMaskedDocument(false);
        setIsUpdate(true);
        setPersonId(row.row.id);
        setTitleInsured("Editar asegurado");
        if (showNewFormInsurance) {
            setOpenModal(true);
        }
        else {
            setOpenModalAddInsurance(true);
        }
        listIdentificationType.forEach(function (item) {
            if (item.name === "Pasaporte" && item.id === row.row.idType) {
                setIsMaskedDocument(true);
            }
        });
        if (showNewFormInsurance) {
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { Id: row.row.id, IdType: row.row.idType, DocumentNumber: row.row.documentNumber, Name: row.row.firstNameA, SecondName: row.row.firstNameB, LastNameA: row.row.lastNameA, LastNameB: row.row.lastNameB, marriedName: row.row.marriedName, Birthday: newFormattedDateYYMMDD(row.row.dob), PhoneNumber: row.row.phone1, idInsuredType: row.row.idInsuredType }));
        }
        else {
            setDataFormInsuranceSp({
                Id: row.row.id,
                idType: row.row.idType,
                DocumentNumber: row.row.documentNumber,
                firstName: row.row.firstNameA,
                secondName: row.row.firstNameB,
                lastNameA: row.row.lastNameA,
                lastNameB: row.row.lastNameB,
                marriedName: row.row.marriedName,
                birthday: newFormattedDateYYMMDD(row.row.dob),
                phoneNumber: row.row.phone1,
                idInsuredType: row.row.idInsuredType,
            });
        }
    };
    var handleSearch = function (value, isInsuranceFlag) {
        var document = value.target.value;
        if (document) {
            var cleanedDocument = document.replace(/-/g, "");
            var numberDocument = Number(cleanedDocument);
            if (!isNaN(numberDocument)) {
                setIsInsurance(isInsuranceFlag);
                setDocument(numberDocument);
                setTrigger(true);
            }
        }
    };
    var searchInsurancePerson = useCallback(function (value) {
        handleSearch(value, true);
    }, []);
    return useMemo(function () { return ({
        handleAddInsured: handleAddInsured,
        setInsuranceStorybook: setInsuranceStorybook,
        handleSubmitInsured: handleSubmitInsured,
        editInsured: editInsured,
        searchInsurancePerson: searchInsurancePerson,
    }); }, [
        handleAddInsured,
        setInsuranceStorybook,
        handleSubmitInsured,
        editInsured,
        searchInsurancePerson,
    ]);
};
export default useInsurance;
